export default __webpack_public_path__ + "static/media/finalStep.d469d665.svg";